import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import '../components/components.css';

export default function Admin() {
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(function () {
    let isL = Cookies.get('isLoggedIn');
    if (isL !== undefined) {
      if (isL) {
        setLoggedIn(true);
      } else {
        setLoggedIn(false);
      }
    }
  }, []);

  function logUser(e) {
    e.preventDefault();
    if (username === 'akulsr0' && password === 'Akul@3116') {
      Cookies.set('isLoggedIn', true);
      setLoggedIn(true);
    } else {
      window.alert('Invalid Credentials');
    }
  }

  function logoutAdmin() {
    Cookies.remove('isLoggedIn');
    setLoggedIn(false);
  }

  if (!isLoggedIn) {
    return (
      <div className='container mt-2 pt-4'>
        <center>
          <h3 className='oswald'>Admin Panel</h3>
          <form onSubmit={logUser}>
            <input
              className='admin-input'
              type='text'
              placeholder='username'
              onChange={(e) => setUsername(e.target.value)}
            />{' '}
            <br />
            <input
              className='admin-input'
              type='password'
              placeholder='password'
              onChange={(e) => setPassword(e.target.value)}
            />{' '}
            <br />
            <button className='admin-button' onClick={logUser}>
              login
            </button>
          </form>
        </center>
      </div>
    );
  } else {
    return (
      <div className='container mt-2'>
        <center>
          <h3 className='oswald'>Admin Panel</h3>
          <hr />
          <h5 className='oswald mb-3'>Add Blog</h5>
          <form
            action='https://akulweb.herokuapp.com/add-blog'
            method='post'
            className='mt-2'
          >
            <input
              className='admin-input'
              type='text'
              name='serialId'
              placeholder='Serial ID'
            />{' '}
            <br />
            <input
              className='admin-input'
              type='text'
              name='title'
              placeholder='Title'
            />{' '}
            <br />
            <input
              className='admin-input'
              type='text'
              name='slug'
              placeholder='Slug'
            />{' '}
            <br />
            <input
              className='admin-input'
              type='text'
              name='tags'
              placeholder='Tags'
            />{' '}
            <br />
            <input
              className='admin-input'
              type='text'
              name='description'
              placeholder='Description'
            />{' '}
            <br />
            <button className='admin-button'>Add</button>
          </form>
          <br />

          <h5 className='oswald mb-3'>Add Project</h5>
          <form
            action='https://akulweb.herokuapp.com/add-project'
            method='post'
          >
            <input
              type='text'
              name='name'
              placeholder='Name'
              className='admin-input'
            />{' '}
            <br />
            <input
              type='text'
              name='link'
              placeholder='Link'
              className='admin-input'
            />{' '}
            <br />
            <input
              type='text'
              name='description'
              placeholder='Description'
              className='admin-input'
            />{' '}
            <br />
            <button className='admin-button'>Add</button>
          </form>
          <br />

          <h5 className='oswald mb-3'>Add OSS</h5>
          <form
            action='https://akulweb.herokuapp.com/add-oss'
            method='post'
            className='mt-2'
          >
            <input
              className='admin-input'
              type='text'
              name='title'
              placeholder='Title'
            />{' '}
            <br />
            <input
              className='admin-input'
              type='text'
              name='link'
              placeholder='Link'
            />{' '}
            <br />
            <input
              className='admin-input'
              type='text'
              name='tags'
              placeholder='Tags'
            />{' '}
            <br />
            <input
              className='admin-input'
              type='text'
              name='description'
              placeholder='Description'
            />{' '}
            <br />
            <button className='admin-button'>Add</button>
          </form>

          <br />
          <br />

          <button className='admin-button' onClick={logoutAdmin}>
            Logout
          </button>
          <br />
          <br />
        </center>
      </div>
    );
  }
}
